import PauseLot from './component'

export default PauseLot
